export default __webpack_public_path__ + "static/iacp-f0339e117501348b1bb32109508db232.webp";